import PropTypes from 'prop-types';
import React from 'react';
import CardholderThankYouImage from 'images/signups/card/family-card.png';
import BrandMomentCard from 'react/signups/card/common/BrandMomentCard';

export default function CardholderCard({ cardholderFirstName }) {
  const caption = `${cardholderFirstName} is the Cardholder`;
  const copy = 'The Cardholder will be able to:';
  const listItems = [
    'Use the True Link Visa Card to make purchases',
    'See recent transactions, upcoming transfers, and the card balance',
    "Access True Link's knowledgeable and compassionate customer support team",
  ];

  return (
    <BrandMomentCard
      cardCaption={caption}
      cardCopy={copy}
      cardListItems={listItems}
      imgAlt="Cardholder Thank You"
      imgSrc={CardholderThankYouImage}
    />
  );
}

CardholderCard.propTypes = {
  cardholderFirstName: PropTypes.string.isRequired,
};
